import React from "react";
import Typography from "../../../common/typography/index.component";
import CrossIcon from "../../../assets/icons/cross.icon";
import { useTranslation } from "react-i18next";
import ResponsiveHelper from "common/helpers/responsive.helper";
import {
  COLOR_SPUN_PEARL,
  COLOR_WHITE,
} from "../../../constants/colors.constants";

import "./index.component.scss";

function AuthDialogHeader({
  hideAuthDialogCallback,
  primaryColor,
  activeAuthView,
  primaryTextColor,
}) {
  const { t } = useTranslation();
  const screenWidth = window.innerWidth;
  const isMobileView = ResponsiveHelper.isMobile(screenWidth);

  const getMainHeading = (activeAuthView) => {
    switch (activeAuthView) {
      case "signIn":
        return t("authDialog.signInScreenHeading");
      case "signUp":
        return t("authDialog.createNewAccount");
      case "otpVerify":
        return t("authDialog.otpVerification");
      case "phoneVerify":
        return t("authDialog.verifyPhone");
      case "guestCheckout":
        return t("authDialog.continueAsGuest");
      default:
        return null;
    }
  };

  return (
    <div
      style={{
        backgroundColor: isMobileView ? primaryColor : COLOR_WHITE,
      }}
      className="auth-mobile-header-wrapper"
    >
      <div className="auth-mobile-header-left">
        <Typography
          variant="h1"
          weight="semiBold"
          className="auth-mobile-header-main-heading"
          fontColor={isMobileView ? COLOR_WHITE : primaryTextColor}
        >
          {getMainHeading(activeAuthView)}
        </Typography>
      </div>
      <div className="auth-mobile-header-right">
        <CrossIcon
          fill={isMobileView ? primaryColor : COLOR_SPUN_PEARL}
          size={{ width: 16, heigth: 16 }}
          className="auth-mobile-header-close-dialog"
          onClickCallback={hideAuthDialogCallback}
        />
      </div>
    </div>
  );
}

export default AuthDialogHeader;
